import React, { useState } from 'react'
import classes from './SupportingDocuments.module.css'
import SubSectionHeader from '../../Shared/SubSectionHeader'
import { useAppContext } from '../../../Context/AppContext'
import FileHandler, { FileViewer } from '../../Shared/FileHandler/FileHandler'
import { getFileIconCss } from '../../../Utility';
import { ActivityString } from '../../../Constants'

const SupportingDocuments = props => {
  const { transporterInfo, isEditable } = useAppContext();
  const [viewFileData, setViewFileData] = useState(null);
  const [viewFileUrl, setViewFileUrl] = useState('');
  const [viewOpen, setViewOpen] = useState(false);
  const handleViewFile = (url, data) => {
    setViewFileUrl(url);
    setViewFileData(data);
    setViewOpen(true);
  };

  return (
    <div className={classes.container + ' sub-section-container'}>
      {Object.keys(transporterInfo).length === 0 ? null : (
        <>
          <SubSectionHeader title="Attachments"></SubSectionHeader>
          {isEditable ? (
            <EditMode
              attachments={transporterInfo.contract_attachments}
              transporterId={transporterInfo.transporter_id}
              onViewFile={handleViewFile}
            />
          ) : (
            <ReadOnly
              attachments={transporterInfo.contract_attachments}
              onViewFile={handleViewFile}
            />
          )}
          {viewOpen && (
            <FileViewer
              viewFile={viewOpen}
              setViewFile={setViewOpen}
              viewFilePath={viewFileUrl}
              fileViewHeader={viewFileData?.title}
              fileName={viewFileData?.fileName}
              numPages={viewFileData?.numPages || null}
              loading={false}
              onDocumentLoadSuccess={() => {}}
            />
          )}
        </>
      )}
    </div>
  )
}



const EditMode = ({ attachments = [], transporterId, onViewFile }) => (
  <div className={classes['cards-container']}>
    {attachments.map(a => (
      <Card title={a.name} fileName={a['file_name'] || 'No file'} key={a.name}>
        <FileHandler
          onUpload={(fileid, fileName) => {
            a['blob_url'] = fileid;
            a['file_name'] = fileName;
            a['uploaded_on'] = new Date().toISOString();
          }}
          transporterId={transporterId}
          lastUpdated={a.uploaded_on}
          modulename={'Supporting Documents'}
          screen={ActivityString.ContractInfo}
          fileDescription={a.name}
          title={a.name}
          fileId={a.blob_url}
          fileName={a.file_name}
          onViewFile={onViewFile}
        />
      </Card>
    ))}
  </div>
);

const ReadOnly = ({ attachments = [], onViewFile }) => (
  <div className={classes['cards-container']}>
    {attachments.map(a => (
      <Card title={a.name} fileName={a['file_name']} key={a.name}>
        <FileHandler
          fileId={a.blob_url}
          lastUpdated={a.uploaded_on}
          fileName={a['file_name']}
          className={classes['margin-top-5px']}
          modulename={'Supporting Documents'}
          screen={ActivityString.ContractInfo}
          fileDescription={a.name}
          title={a.name}
          onViewFile={onViewFile}
        />
      </Card>
    ))}
  </div>
);

const Card = ({ title, fileName, children }) => {
  const fileType = getFileIconCss(fileName);

  return (
    <div className={classes.card} >
      <div className={classes.header}>
        {title.replace(/([a-z])([A-Z])/g, '$1 $2')}
      </div>
      <div className={classes['uploader']} title={fileName}>
        <img alt='img' src={fileType.icon} className={classes['attachment-filetype-icon']}></img>
      </div>
      {children}
    </div>
  );
}



export default SupportingDocuments
